import { useLeadViewDisplay } from "@/features/leads/api/useLeadFormConfig";

/**
 * Read-side of the View Lead show/hide config (Settings → Manage →
 * View Lead Display). Absent keys are visible, so defaults need no state and a
 * newly created field shows up without anyone re-ticking it.
 *
 * Tenant-wide, read from the server config. It used to come from a
 * redux-persist slice, which made it per-browser and wiped it on every logout —
 * this is an ORG display policy, so the whole team sees the same drawer.
 */
export function useViewLeadFieldVisibility() {
  const display = useLeadViewDisplay();

  const isFieldVisible = (key: string) =>
    display?.sections?.[key] !== false && display?.fields?.[key] !== false;
  const isCustomFieldVisible = (id: string | number) =>
    display?.customFields?.[String(id)] !== false;

  /**
   * Whether a collapsible section should already be open when the drawer
   * opens. Absent = collapsed (the opposite default to visibility above —
   * the drawer opens compact unless someone opts a section open).
   */
  const isExpandedByDefault = (key: string) =>
    display?.expandedByDefault?.[key] === true;

  return { isFieldVisible, isCustomFieldVisible, isExpandedByDefault };
}
